<!-- NotificationOverlay global -->
<app-notification-overlay />

<!-- Update banner global -->
<app-update-banner />

<!-- Router outlet -->
<router-outlet />
